import { formatCount } from "./formatCount";
import { filterConstants } from "./filtersConfig";
import formatUnit from "./formatUnit";

export const getDateLabel = (filterKey: string): string => {
  const date = new Date(filterKey);
  const todayDate = new Date();

  const isCurrentDay = date.getDate() === todayDate.getDate();
  const isTomorrow = date.getDate() === todayDate.getDate() + 1;
  const isCurrentMonth = date.getMonth() === todayDate.getMonth();
  const isCurrentYear = date.getFullYear() === todayDate.getFullYear();

  if (isCurrentDay && isCurrentMonth && isCurrentYear) return "Today";
  if (isTomorrow && isCurrentMonth && isCurrentYear) return "Tomorrow";
  return filterKey;
};

const formatWithUnits = (categoryKey: string, min: string, max?: string) => {
  if (!max && categoryKey.toLowerCase() === "mileage") {
    return `${min} mi or Above`;
  }

  if (min && max && categoryKey.toLowerCase() === "mileage") {
    return `${min} mi - ${max} mi`;
  }

  if (!max && categoryKey.toLowerCase() === "capcleanprice") {
    return `£${min} or Above`;
  }

  if (min && max && categoryKey.toLowerCase() === "capcleanprice") {
    return `£${min} - £${max}`;
  }
};

const getMaxLimit = (categoryKey: string): string => {
  if (categoryKey.toLowerCase() === "mileage") {
    return filterConstants.maxMileageLimit;
  }

  if (categoryKey.toLowerCase() === "capcleanprice") {
    return filterConstants.maxCAPCleanLimit;
  }
};

const getNumberAndUnit = (value: string): string[] => {
  const number = value.match(/\d+/g)[0];
  const unit = value.replace(number, "");

  return [number, unit];
};

const getFilterLabel = (categoryKey: string, filterKey: string): string => {
  if (filterKey.match(/[a-zA-Z]{3} [0-9]{2} [a-zA-Z]{3} [0-9]{4}/)) {
    return getDateLabel(filterKey);
  }

  if (
    categoryKey.toLowerCase() === "mileage" ||
    categoryKey.toLowerCase() === "capcleanprice"
  ) {
    const mileageInterval = filterKey.split("..");
    const minValue = mileageInterval[0];
    const maxValue = mileageInterval[1];

    if (maxValue === "0" || maxValue === getMaxLimit(categoryKey)) {
      const formattedDisplayValue = formatCount(Number(minValue));
      return formatWithUnits(categoryKey, formattedDisplayValue);
    }

    return formatWithUnits(
      categoryKey,
      formatCount(Number(minValue)),
      formatCount(Number(maxValue))
    );
  }

  if (categoryKey.toLowerCase() === "dateregistered") {
    const mileageInterval = filterKey.split("..");
    const minValueString = mileageInterval[0];
    const maxValueString = mileageInterval[1];

    const [minNumber, minUnit] = getNumberAndUnit(minValueString);
    const [maxNumber, maxUnit] = getNumberAndUnit(maxValueString);

    const minValue = `${minNumber} ${formatUnit(minUnit)}`;
    const maxValue = `${maxNumber} ${formatUnit(maxUnit)}`;
    if (maxValueString === filterConstants.maxVehicleAgeLimit) {
      return `${minNumber} ${formatUnit(minUnit)} or Above`;
    }

    return `${minValue} - ${maxValue}`;
  }

  const filterLabels = {
    salechannel: { "e-auction": "Online Auction" },
    logbookstatus: {
      logbookstatus: "V5 Present",
      true: "V5 Present",
    },
    hasbatteryhealthreport: {
      hasbatteryhealthreport: "Report Available",
      true: "Report Available",
    },
    mileagewarranted: {
      mileagewarranted: "Must be warranted mileage",
      true: "Must be warranted mileage",
    },
    grade: {
      unknown: "Grade Unknown",
      unclassified: "Grade Unclassified",
    },
    vattype: {
      unknown: "VAT Unknown",
    },
    hasconditionreport: {
      hasconditionreport: "Only show results with a Condition Report",
      true: "Only show results with a Condition Report",
    },
    colourgeneric: {
      unknown: "Colour Unknown",
    },
    mechanicalreporttype: {
      "128 vehicle inspection": "128 Vehicle Inspection*",
      "bca essential check": "BCA Essential Check*",
    },
  };

  if (!filterLabels[categoryKey.toLowerCase()]) return filterKey;
  return (
    filterLabels[categoryKey.toLowerCase()][filterKey.toLowerCase()] ||
    filterKey
  );
};

export default getFilterLabel;
